import { createSelector } from '@ngrx/store';
import { selectPnrState } from '../reducers/pnr.reducer';

export const getRemarks = createSelector(selectPnrState, (state) => state.remarks);

export const getRemarkSavedOnProccess = createSelector(
  selectPnrState,
  (state) => state.remarkSavedOnProccess
);
